import { getUserUuidFromToken } from 'Shared/utils';
import type { Interceptor } from 'viewup-lib/common';
import { getSessionStorage } from 'viewup-lib/common';
import { tokenRepository } from './httpClient';

export class HeaderInterceptor implements Interceptor {
  requestInterceptorOnFulfilled = async (config) => {
    const token = await tokenRepository.getToken();
    config.headers['x-tab-id'] = getSessionStorage('tabId');
    config.headers['x-requester-id'] = getUserUuidFromToken(token)?.userUuid;
    if (typeof window !== 'undefined') {
      config.headers['viewup-viewport-height'] = window.innerHeight;
      config.headers['viewup-viewport-width'] = window.innerWidth;
    }
    return config;
  };
}
